import React, { useContext } from "react";
import { DF_LO0023Context } from "../context";
import RotaFreteForm from "../../DF_LO0021/Grid/RotaFreteForm";

function GridBody({ ID_Tabela_Frete: ID_Tabela_Frete_Prop, onClose } = {}) {
  const ctx = useContext(DF_LO0023Context);
  const ID_Tabela_Frete = ID_Tabela_Frete_Prop ?? ctx?.ID_Tabela_Frete;
  return <RotaFreteForm mode="view" ID_Tabela_Frete={ID_Tabela_Frete} onClose={onClose} />;
}

export default GridBody;